import React from 'react';
import SafeImage from '../../SafeImage';

// Per-image color assignment — the higher-fidelity alternative to the plain
// color list: lets each individual product photo carry its own color, so the
// storefront can show the exact photo for the color a customer picks instead
// of one shared swatch list for every image.
const ImageColorsInput = ({ rows, onUpdate }) => (
  <div>
    <label className="dpc-label text-ink-soft block mb-1.5">Photo colors (optional)</label>
    <p className="text-xs text-ink-faint mb-3">
      Assign a color to specific photos so the storefront can show the exact photo for the color a customer picks, instead of one shared swatch list.
    </p>
    <div className="space-y-3">
      {rows.map((row) => (
        <div key={row.imageId} className="flex items-center gap-3">
          <SafeImage src={row.imageUrl} alt={row.label} className="w-14 h-14 object-cover rounded-sm border border-ink-faint shrink-0" />
          <span className="text-xs text-ink-faint w-20 shrink-0">{row.label}</span>
          <input
            type="text"
            value={row.colorName}
            onChange={(e) => onUpdate(row.imageId, 'colorName', e.target.value)}
            placeholder="e.g. Cerise Red"
            className="flex-1 border border-ink-faint rounded-sm px-3 py-2 text-sm bg-surface focus:ring-1 focus:ring-accent focus:border-accent"
          />
          <input
            type="color"
            value={/^#[0-9a-fA-F]{6}$/.test(row.colorCode) ? row.colorCode : '#000000'}
            onChange={(e) => onUpdate(row.imageId, 'colorCode', e.target.value)}
            className="w-10 h-10 border border-ink-faint rounded-sm cursor-pointer shrink-0"
            aria-label={`Color for ${row.label}`}
          />
        </div>
      ))}
    </div>
  </div>
);

export default ImageColorsInput;
